import React from 'react';
import colors from 'src/style/colors';

const DottedLineSmall = ({ lineStyled }) => {
  return (
    <div
      css={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space between',
        flex: 1,
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: -45,
        transform: lineStyled === 'end' ? 'rotate(180deg)' : '',
      }}
    >
      <div
        css={{
          width: 3,
          backgroundColor: colors.yellow,
          flex: 2,
        }}
      />
      <div
        css={{
          width: 3,
          flex: 3,
        }}
      />
      <div
        css={{
          width: 3.3,
          backgroundColor: colors.yellow,
          flex: 2,
        }}
      />
      <div
        css={{
          width: 3.3,
          flex: 3,
        }}
      />
      <div
        css={{
          width: 3.5,
          backgroundColor: colors.yellow,
          flex: 4,
        }}
      />
      <div
        css={{
          width: 3.5,
          flex: 3,
        }}
      />
      <div
        css={{
          width: 3.7,
          backgroundColor: colors.yellow,
          flex: 6,
        }}
      />
      <div
        css={{
          width: 3.7,
          flex: 3,
        }}
      />
      <div
        css={{
          width: 3.9,
          backgroundColor: colors.yellow,
          flex: 7,
        }}
      />
      <div
        css={{
          width: 3.9,
          flex: 3,
        }}
      />
      <div
        css={{
          width: 4,
          backgroundColor: colors.yellow,
          flex: 8,
        }}
      />
    </div>
  );
};
export default DottedLineSmall;
